import BaseModal from 'components/Modals/BaseModal';

const Modal = ({ show, handleShow }) => {
  return (
    <BaseModal show={show} handleShow={handleShow} title="Add Assignments" size="lg"></BaseModal>
  );
};

export default Modal;
